<div [formGroup]="formGroup">
    <div class="flex gap-12" [formGroupName]="controlName">
        <input
            pInputText
            [formControlName]="'minLabel'"
            class="w-full height-40"
            type="number"
            step="any"
            placeholder="{{ 'default-cm-minValue' | translate: 'Min Value' }}"
        />
        <input
            pInputText
            [formControlName]="'maxLabel'"
            class="w-full height-40"
            type="number"
            step="any"
            placeholder="{{ 'default-cm-maxValue' | translate: 'Max Value' }}"
        />
    </div>
    @if (formGroup.get([controlName])?.hasError('minGreaterThanMax')) {
        <div>
            <p class="text-red-500 text-sm">
                {{ 'default-cm-numberRangeValidation' | translate: 'Min Value must be less than Max Value' }}
            </p>
        </div>
    }
</div>
